// extracted by mini-css-extract-plugin
module.exports = {"container":"e_IG","icon":"e_JG"};